import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Modal = function Modal(props) {
    const {
        title, children, closebuttontext, show, showheader, showfooter, setshow,
        confirmbuttontext, confirmaction, modalcardstyle,
    } = props;

    return show && (
        <div className="modal is-active">
            <div className="modal-background" />
            <div className="modal-card" style={modalcardstyle}>
                {showheader && (
                    <header className="modal-card-head" style={{ background: '#95B5C7' }}>
                        <p className={styles['modal-card-title']}>
                            {title}
                        </p>
                        <button type="button" aria-label="close" className="delete" onClick={() => setshow(false)} />
                    </header>
                )}
                <section className="modal-card-body">
                    {!showheader && !showfooter && (
                        <div className="level">
                            <div className="level-item has-text-right">
                                <p className="modal-card-title" />
                                <button type="button" aria-label="close" className="delete" onClick={() => setshow(false)} />
                            </div>
                        </div>
                    )}
                    <div className="content">
                        {children}
                    </div>
                </section>
                {showfooter && (
                    <footer className="modal-card-foot" style={{ background: '#FFFFFF', borderTop: '0px' }}>
                        <div className="has-text-centered" style={{ width: '100%' }}>
                            <button type="button" className="button" onClick={() => setshow(false)}>{closebuttontext}</button>
                            {confirmbuttontext && (
                                <button
                                    type="button"
                                    className="button"
                                    style={{
                                        background: '#29aae2',
                                        color: '#ffffff',
                                    }}
                                    onClick={() => { setshow(false); confirmaction(); }}
                                >
                                    {confirmbuttontext}
                                </button>
                            )}
                        </div>
                    </footer>
                )}
            </div>
        </div>
    );
};

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    closebuttontext: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    showheader: PropTypes.bool.isRequired,
    showfooter: PropTypes.bool.isRequired,
    setshow: PropTypes.func.isRequired,
    confirmbuttontext: PropTypes.string.isRequired,
    confirmaction: PropTypes.func.isRequired,
    modalcardstyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

Modal.defaultProps = {
    modalcardstyle: {},
};

export default Modal;
